import { GlobalStore } from "../store/global/GlobalStore";
import { Balance } from "../store/global/getBalances";
import { Amount } from "../types/amount";
import { Hash } from "viem";
import { DUMMY_WALLET } from "../config/consts";
import { isAddressEqual } from "../utils/tokenUtils";

export const useBalanceForSymbol = (tokenAddress: Hash | undefined) => {
  const balance = GlobalStore.useState(s => s.balances).find(balance =>
    isAddressEqual(balance.tokenAddress, tokenAddress ?? DUMMY_WALLET)
  );
  if (tokenAddress == null) return undefined;
  if (balance != null) return balance;
  const zeroBalance: Balance = { tokenAddress: tokenAddress, balance: Amount.ZERO };
  return zeroBalance;
};
